import Collector from '../collectors/Collector';
import * as number from './collectors.number';
export {
  Collector,
  number
};
